// extracted by mini-css-extract-plugin
module.exports = {"button":"AddButton_button__2hWrL","icon":"AddButton_icon__5u8Fs"};